/** Google Ads – tag globalny i akcje konwersji */
export const GOOGLE_ADS_ID = "AW-17965488298";
export const GOOGLE_ADS_CONTACT_CONVERSION = "AW-17965488298/6F4wCNSWtYYcEKqxzvZC";
export const GOOGLE_ADS_QUOTE_CONVERSION = "AW-17965488298/rDvACJPe1sAcEKqxzvZC";

const CONSENT_LS_KEY = "cookieConsent";
const CONSENT_VERSION = "1.1";

type StoredConsent = {
    version: string;
    marketing?: boolean;
};

declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void;
        dataLayer?: unknown[];
    }
}

function hasMarketingConsent(): boolean {
    if (typeof window === "undefined") return false;
    try {
        const raw = localStorage.getItem(CONSENT_LS_KEY);
        if (!raw) return false;
        const parsed = JSON.parse(raw) as StoredConsent;
        return parsed.version === CONSENT_VERSION && parsed.marketing === true;
    } catch {
        return false;
    }
}

function grantAdsConsent(): void {
    window.gtag?.("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
    });
}

/** Tag AW jest już w layoutcie; po zgodzie marketingowej tylko dopina config (Consent Mode). */
export function loadGoogleAdsTag(): void {
    if (typeof window === "undefined" || !GOOGLE_ADS_ID) return;
    window.gtag?.("config", GOOGLE_ADS_ID);
}

function fireGoogleAdsConversion(sendTo: string): void {
    if (!hasMarketingConsent() || typeof window === "undefined") return;
    grantAdsConsent();
    loadGoogleAdsTag();
    window.gtag?.("event", "conversion", { send_to: sendTo });
}

/** Wywołaj po udanym wysłaniu formularza kontaktowego lub kliknięciu numeru telefonu. */
export function trackGoogleAdsContactConversion(): void {
    fireGoogleAdsConversion(GOOGLE_ADS_CONTACT_CONVERSION);
}

/** Wywołaj po udanym wysłaniu formularza wyceny na landingu wstan-zza-biurka. */
export function trackGoogleAdsQuoteConversion(): void {
    fireGoogleAdsConversion(GOOGLE_ADS_QUOTE_CONVERSION);
}
